import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NotFoundScreen() {
  const { t } = useTranslation();

  return (
    <section className="bg-primary border border-border rounded-md p-3.5">
      <p>{t('website.notFound.message')}</p>
      <Link
        to="/"
        className="border-0 rounded-[10px] px-3.5 py-2.5 cursor-pointer bg-secondary text-text inline-block"
      >
        {t('website.notFound.backToCatalog')}
      </Link>
    </section>
  );
}
